import { isProduction } from '../environment';
import { DocsAPI as RealDocsAPI } from './docs-api';
import { DocsAPI as MockDocsAPI } from './mock-docs-api';

const SelectedDocsAPI = isProduction() ? RealDocsAPI : MockDocsAPI;

export default SelectedDocsAPI;